import { X } from "lucide-react";
import React, { useState } from "react";
import Loading from "../../shared/Loading";
import CustomArea from "../../shared/CustomArea";
import CustomInput from "../../shared/CustomInput";

const AddModule = ({
  closeAddModule,
  loading,
  myModule,
  setMyModule,
  handleAddModule,
}) => {
  const [errors, setErrors] = useState({});
  const validate = () => {
    const newErrors = {};
    if (!myModule.name?.trim()) {
      newErrors.name = "Module name is required";
    }
    if (!myModule.description?.trim()) {
      newErrors.description = "Module description is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onNext = () => {
    if (validate) {
      handleAddModule();
    }
  };
  return (
    <div
      onClick={closeAddModule}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[900px] overflow-y-auto h-[550px] bg-white rounded-[10px] relative"
      >
        <div
          onClick={closeAddModule}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="p-[15px]">
          <p className="font-medium text-[15px] text-[#222222]">
            Create a new module
          </p>
          <p className="text-[#000000] font-semibold text-[20px]">
            Module Information
          </p>
          <p className="text-[#5C5C5C] text-[14px] font-normal">
            Add a new module to group related permissions together, making it
            easier to organize and manage access control across the system.
          </p>
          <div className="my-[20px] w-full">
            <div className="flex w-[95%] mb-[20px] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Role name"
              >
                Module name
              </label>
              <CustomInput
                placeholder="Enter module name"
                type="text"
                value={myModule?.name}
                onChange={(e) =>
                  setMyModule({ ...myModule, name: e.target.value })
                }
              />
              {errors.name && (
                <p className="text-red-500 text-sm mt-1">{errors.name}</p>
              )}
            </div>
            <div className="flex w-[95%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Role description"
              >
                Module description
              </label>
              <CustomArea
                placeholder="Enter module description"
                type="text"
                value={myModule?.description}
                onChange={(e) =>
                  setMyModule({ ...myModule, description: e.target.value })
                }
              />
              {errors.description && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.description}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="absolute bottom-[10px] w-full px-[20px] left-0 flex items-center gap-[10px] justify-end">
          <button
            onClick={closeAddModule}
            className="bg-[#F3F3F3] h-[35px] px-[20px] rounded-[30px] text-[#5C5C5C] font-medium text-[15px]"
          >
            Close
          </button>
          <button
            onClick={onNext}
            disabled={loading}
            className="h-[35px] bg-[#000000] rounded-[30px] flex items-center justify-center gap-[5px] px-[15px] text-[15px] font-bold text-white"
          >
            {loading && <Loading />}
            Add Module
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddModule;
